import { render, staticRenderFns } from "./CallPartnerTariffZoneGroup.vue?vue&type=template&id=30dbe171&"
import script from "./CallPartnerTariffZoneGroup.vue?vue&type=script&lang=ts&"
export * from "./CallPartnerTariffZoneGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports